import { rtkApi } from '@/apis/rtkApi';
import {
  CreateEmailByAdminRequest,
  GetEmailsByAdminRequest,
  GetEmailsByAdminResponse,
  UpdateEmailByAdminRequest,
} from '@/types/EmailType';

export const emailApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmailsByAdmin: builder.query<
      GetEmailsByAdminResponse,
      GetEmailsByAdminRequest
    >({
      query: (payload) => ({ url: `/admin/email`, params: payload }),
      providesTags: ['Admin Email'],
    }),
    getEmailsByCategory: builder.query<Record<string, any[]>, void>({
      query: () => ({ url: `/admin/email/categories` }),
      providesTags: ['Admin Email'],
    }),
    getTemplatesByCategory: builder.query<any[], string>({
      query: (category) => ({ url: `/admin/email/templates/${category}` }),
      providesTags: ['Admin Email'],
    }),
    createEmailByAdmin: builder.mutation<void, CreateEmailByAdminRequest>({
      query: (request) => ({
        url: `/admin/email`,
        method: 'POST',
        data: request,
      }),
      invalidatesTags: ['Admin Email'],
    }),
    updateEmailByAdmin: builder.mutation<void, UpdateEmailByAdminRequest>({
      query: (request) => ({
        url: `/admin/email/${request.id}`,
        method: 'PUT',
        data: request,
      }),
      invalidatesTags: (_response, _result, request) => [
        'Admin Email',
        { type: 'Admin Email', id: request.id },
      ],
    }),
    toggleEmailByAdmin: builder.mutation<{ isActive: boolean }, string>({
      query: (emailId) => ({
        url: `/admin/email/${emailId}/toggle`,
        method: 'PUT',
      }),
      invalidatesTags: ['Admin Email'],
    }),
    sendTestEmail: builder.mutation<
      { success: boolean; message: string },
      { emailId: string; testEmailAddress: string; params?: any }
    >({
      query: (data) => ({
        url: `/admin/email/test`,
        method: 'POST',
        data,
      }),
    }),
    removeEmailByAdmin: builder.mutation<void, string>({
      query: (emailId) => ({
        url: `/admin/email/${emailId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admin Email'],
    }),
  }),
});

export const {
  useGetEmailsByAdminQuery,
  useGetEmailsByCategoryQuery,
  useGetTemplatesByCategoryQuery,
  useCreateEmailByAdminMutation,
  useUpdateEmailByAdminMutation,
  useToggleEmailByAdminMutation,
  useSendTestEmailMutation,
  useRemoveEmailByAdminMutation,
} = emailApi;
